export const viewingsAttributesIDs = {
  pauseViewingsWhenApprovedApplication:
    'pause_viewings_when_approved_application',
}
